export const baseUrl = window._env_?.REACT_APP_BASE_URL;
export const reportUrl = window._env_?.REACT_REPORT_URL;
export const appEnv = window._env_?.APP_ENV;
export const s3BaseUrl = window._env_?.S3_BASE_URL ?? "https://mobitutorza-assets.s3.af-south-1.amazonaws.com";